export function prepMapPayload(apiData) {
  const warnings = [];
  const settings = apiData?.settings || {};
  const statuses = apiData?.statuses?.rows || [];

  const categoryMap = new Map();

  for (const status of statuses) {
    if (typeof status.id !== "number") continue;

    const key = status.id;

    categoryMap.set(key, {
      id: status.id,
      label: status.name || `Status ${status.id}`,
      pinImage: status.pin_file_path || null,
      colorPrimary: status.color_primary || null,
      colorSecondary: status.color_secondary || null,
      defaultVisible: false,
      projects: [],
    });
  }

  const projects = apiData?.projects || [];

  for (let idx = 0; idx < projects.length; idx++) {
    const p = projects[idx];
    const id = p?.id;
    const title = p?.title || p?.name || `(untitled #${idx})`;
    const statusKey = Number(p?.status_id);

    if (!statusKey || !categoryMap.has(statusKey)) {
      warnings.push(`"${title}" missing or unknown status_id`);
      continue;
    }

    let geom = p?.geometry;
    if (geom && typeof geom === "string") {
      try {
        geom = JSON.parse(geom);
      } catch {
        warnings.push(`"${title}" bad geometry JSON`);
        geom = null;
      }
    }

    const catProjects = categoryMap.get(statusKey).projects;
    let existing = catProjects.find((prj) => prj.id === p.id);

    if (!existing) {
      existing = {
        id: p.id,
        name: title,
        featureType: p.type || null,
        geometry: [],
        details: p.description,
        groupId: p.groupId ?? p.group_id ?? null,
        pageId: p.pageId ?? p.page_id ?? null,
        groupSlug: p.group_slug ?? p.groupSlug ?? null,
        pageSlug: p.page_slug ?? p.pageSlug ?? null,
        status_id: p.status_id,
      };
      catProjects.push(existing);
    }

    if (Array.isArray(geom)) {
      existing.geometry.push(...geom);
    } else if (geom) {
      existing.geometry.push(geom);
    }
  }

  const categories = {};
  for (const [id, cat] of categoryMap.entries()) {
    if (cat.projects.length > 0) categories[id] = cat;
  }

  return { settings, statuses, projects, categories, issues: warnings };
}